import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/ThemeProvider';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import ResultsPage from './pages/ResultsPage';
import ProfilePage from './pages/ProfilePage';
import AnalyticsPage from './pages/AnalyticsPage';
import AnalyticsDetailPage from './pages/AnalyticsDetailPage';
import AboutPage from './pages/AboutPage';
import LoginPage from './pages/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import LoadingScreen from './components/LoadingScreen';
import EmailTest from './components/EmailTest';
import ComparisonPage from './pages/ComparisonPage';
import VisitSchedulePage from './pages/VisitSchedulePage';
import ExpertConnectionPage from './pages/ExpertConnectionPage';
import ChatPage from './pages/ChatPage';
import VideoCallPage from './pages/VideoCallPage';
import FinancialToolsPage from './pages/FinancialToolsPage';
import ROICalculatorPage from './pages/ROICalculatorPage';
import FinancingOptionsPage from './pages/FinancingOptionsPage';
import BudgetPlannerPage from './pages/BudgetPlannerPage';
import CostEstimatorPage from './pages/CostEstimatorPage';
import InvestmentAnalysisPage from './pages/InvestmentAnalysisPage';
import ReportsPage from './pages/ReportsPage';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ThemeProvider defaultTheme="dark">
      <div className="min-h-screen bg-background text-foreground font-mono relative">
        <div className="scanlines crt">
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/analytics/:locationId" element={<AnalyticsDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/email-test" element={<EmailTest />} />
              <Route path="/comparisons" element={<ComparisonPage />} />
              <Route path="/schedule-visit" element={<VisitSchedulePage />} />
              <Route path="/connect-expert" element={<ExpertConnectionPage />} />
              <Route path="/chat/:expertId" element={<ChatPage />} />
              <Route path="/video-call/:expertId" element={<VideoCallPage />} />
              <Route path="/financial-tools" element={<FinancialToolsPage />} />
              <Route path="/roi-calculator" element={<ROICalculatorPage />} />
              <Route path="/financing-options" element={<FinancingOptionsPage />} />
              <Route path="/budget-planner" element={<BudgetPlannerPage />} />
              <Route path="/cost-estimator" element={<CostEstimatorPage />} />
              <Route path="/investment-analysis" element={<InvestmentAnalysisPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;